import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Hero2 from '../../components/hero2/Hero2';
import About2 from '../../components/about2/about2';
import PageTitle from '../../components/pagetitle/PageTitle';
import GetquateSection from '../../components/GetquateSection/GetquateSection';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import Testimonial from '../../components/Testimonial/Testimonial';
import PartnerSection from '../../components/PartnerSection/PartnerSection';
import BlogSection from '../../components/BlogSection/BlogSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/gattomioNero.png'

const HomePage2 = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <PageTitle pageTitle={'Come Funziona'} pagesub={'Come Funziona'} />
            {/*<Hero2 hclass={'wpo-hero-slider'} />*/}
            <About2 hclass={'about-section-s3 section-padding'} />
            <GetquateSection hclass={'pb-200'} />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default HomePage2;